import { useEventsConfigurationService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';
import { LoadingAnimation, NewLine } from 'ui-builder';
import React from 'react';
import GoogleButton from './GoogleButton';

export default function AuthenticationLink() {
  const eventConfigurationService = useEventsConfigurationService();

  const { data: linkData } = useDataLoaderNew(
    eventConfigurationService.getGoogleLink,
  );

  if (linkData) {
    return (
      <div>
        Click the button below to directly integrate Nekst with your Google Account Calendar:
        <NewLine />
        <NewLine />
        <GoogleButton
          onClick={() => {
            window.location.href = linkData.link;
          }}
        />
      </div>
    );
  } else {
    return (
      <LoadingAnimation />
    );
  }
}
